import { Space } from "antd";
import Text from "components/atoms/Text";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { isEditingPlan } from "./utils/helpers";

const Wrapper = styled.div`
  margin-bottom: 100px;
  min-height: calc(100vh);
  padding: 2.5% 20px;

  @media (min-width: 768px) {
    width: 90%;
    margin: 50px auto 100px auto;
  }
`;

const PremiumsTitlesWrapper = styled.div`
  justify-content: center;
  display: flex;
  margin-top: 7%;
  @media (max-width: 768px) {
    padding: 28px;
  }
`;

const WithEditTitleWrapper = ({ showTitle, children }) => {
  if (!showTitle) return children;
  return (
    <Space direction="vertical" size="large">
      <Text sectionTitle big>
        Verify Your Plan Details
      </Text>
      {children}
    </Space>
  );
};

const CreatePlanSteps = ({ isAdmin, setAdvancedTabActive, showEndMessage, email }) => {
  const steps = useSelector((state) => state.plan.steps);

  const current = useSelector((state) => state.plan.current);

  const { values } = useFormikContext();
  const { enterAdvancedDetails } = values;

  useEffect(() => {
    setAdvancedTabActive(enterAdvancedDetails);
  }, [enterAdvancedDetails]);

  let filteredSteps = !enterAdvancedDetails ? steps.filter((item) => item.title !== "Advanced") : steps;
  if (isEditingPlan()) {
    filteredSteps = filteredSteps.filter((item) => item.title !== "Start");
  }

  if (showEndMessage) {
    return (
      <Wrapper>
        <>
          <PremiumsTitlesWrapper>
            <Text sectionTitle>
              {`Thanks for sharing that! We'll email you within 48 hours at ${email} with your recommendation or any
              follow-up questions.`}
            </Text>
          </PremiumsTitlesWrapper>
        </>
      </Wrapper>
    );
  }

  return filteredSteps?.[current] ? (
    <Wrapper>
      <WithEditTitleWrapper showTitle={isEditingPlan()}>
        {React.cloneElement(filteredSteps[current].content, {
          isAdmin,
        })}
      </WithEditTitleWrapper>
    </Wrapper>
  ) : null;
};

export default CreatePlanSteps;
